import React, { act, useState } from "react";
import Styles from "./BankView.module.css";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";

const BankViewModal = ({ open, handleClose, data }) => {
  const [active, setActive] = useState("Injection");

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={Styles.bankViewModal}>
        <div className={Styles.modalHeader}>
          <div>{data?.name || "Listing View"}</div>
          <Close onClick={handleClose} style={{ cursor: "pointer" }} />
        </div>
        <div style={{ width: "100%", padding: "0px 2.5%" }}>
          <div className={Styles.listMainElem}>
            <div className={Styles.eachListElement}>
              <div>Expairy Date</div>
              <div>{data?.expiryAt}</div>
            </div>
            <div className={Styles.eachListElement}>
              <div>Banking Factor</div>
              <div>{data?.bankingFactor}</div>
            </div>
            <div className={Styles.eachListElement}>
              <div>Settlement Rate</div>
              <div>{data?.settlementRate}</div>
            </div>
          </div>
          <div>
            <div className={Styles.selectionCont}>
              <div
                onClick={() => setActive("Injection")}
                className={active === "Injection" && Styles.activeButton}
              >
                Injection
              </div>
              <div
                onClick={() => setActive("Drawal")}
                className={active === "Drawal" && Styles.activeButton}
              >
                Drawal
              </div>
            </div>
            <div className={Styles.listHeader}>
              <div>Start Date</div>
              <div>End Date</div>
              <div>Min. Quantity (MW)</div>
              <div>Req. Quantity (MW)</div>
              <div>Time Slot</div>
            </div>
            <div className={Styles.listDetails}>
              {(active === "Injection"
                ? data?.bankingSlotInjects
                : data?.bankingSlotDrawls
              )?.map((ele) => (
                <div className={Styles.listElem}>
                  <div>{ele?.dateStartAt}</div>
                  <div>{ele?.dateEndAt}</div>
                  <div>{ele?.minimumQty}</div>
                  <div>{ele?.requiredQty}</div>
                  <div>
                    {ele?.slotStartAt === "23:59" ? "24:00" : ele?.slotStartAt}-
                    {ele?.slotEndAt === "23:59" ? "24:00" : ele?.slotEndAt}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BankViewModal;
